import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { Link, useHistory, useParams,Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';
import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }
    handle_hukdisprocess = () =>{
        this.setState({
            confirm: true
        })
    }

    submitData = async () => {
        const queryParams = new URLSearchParams(this.props.location.search)
        await this.detailBloc.fetchCreate({uuid: queryParams.get('uuid') })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    constructor(props) {
        super(props)
        this.state = {
            detai:{},
            hukdis: null
        }
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            detail: response,
                            hukdis:response.hukuman_disiplin
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })

        this.detailBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            success: true,
                            redirect:true
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="skillcertification"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Rekap Absensi</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Rekap Absensi
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            NIP - Nama
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.presensi_summary_employee_nip !== "" ? this.state.detail.presensi_summary_employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                            {" - "}
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <hr />
                                        {/* <Row className="mb-3">
                                            <label className="col-md-3">
                                                Bulan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.presensi_summary_month_name !== "" ? this.state.detail.presensi_summary_month_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tahun
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.presensi_summary_year !== "" ? this.state.detail.presensi_summary_year : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Periode Dari
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.period_start !== "" ? this.dateParse(this.state.detail.period_start) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Periode Sampai
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.period_end !== "" ? this.dateParse(this.state.detail.period_end) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    <hr />

                                    
                                    <br />
                                    <hr />
                                    <br />
                                    <Table className="table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Akumulasi<br/> Terlambat</th>
                                                <th className="text-center">Akumulasi<br/> Pulang Awal</th>
                                                <th className="text-center">Akumulasi<br/> Single Finger</th>
                                                <th className="text-center">Akumulasi<br/> Ketidakhadiran</th>
                                                <th className="text-center">Total<br/> Akumulasi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <td className="text-center">
                                            {
                                                this.state.detail ?
                                                <>{(this.state.detail.presensi_summary_late) !== "" ? this.state.detail.presensi_summary_late : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                            </td>
                                            <td className="text-center">
                                            {
                                                this.state.detail ?
                                                <>{(this.state.detail.presensi_summary_akumulasi_pulang_cepat) !== "" ? this.state.detail.presensi_summary_akumulasi_pulang_cepat : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                            </td>
                                            <td className="text-center">
                                            {
                                                this.state.detail ?
                                                <>{(this.state.detail.presensi_summary_akumulasi_single_finger) !== "" ? this.state.detail.presensi_summary_akumulasi_single_finger : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                            </td>
                                            <td className="text-center">
                                            {
                                                this.state.detail ?
                                                <>{(this.state.detail.presensi_summary_akumulasi_ketidakhadiran) !== "" ? this.state.detail.presensi_summary_akumulasi_ketidakhadiran : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                            </td>
                                            <td className="text-center">
                                            {
                                                this.state.detail ?
                                                <>{(this.state.detail.total_akumulasi) !== "" ? this.state.detail.total_akumulasi : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                            </td>
                                        </tbody>
                                    </Table>
                                    
                                    {
                                    this.state.hukdis ?
                                    <Card>
                                        <div className='card-body text-center alert alert-danger'>
                                            <h5><i className='uil-info-circle'></i> Akumulasi ketidakhadiran Pegawai Bersangkutan sudah memenuhi hukuman disiplin dengan saran hukuman disiplin : </h5>
                                            <h4>
                                            {((this.state.detail.alpha_berturut) == 10 && (this.state.detail.alpha_berturut) > 0)? 'Pemberhentian dengan hormat tidak atas permintaan sendiri sebagai PNS' : this.state.detail.hukuman_disiplin} 
                                            &nbsp;
                                            </h4>
                                            <br />
                                            {/* <button className='btn btn-danger'
                                            onClick={this.handle_hukdisprocess}
                                            >Proses Hukuman Disiplin</button> */}
                                            {/* <Link to="/kepegawaian/hukuman_disiplin.html?create"> */}
                                                {/* <button type='button' className='btn btn-danger'><i className="uil-arrow-right"
                                                onClick={this.handle_hukdisprocess}
                                                ></i> Proses Hukuman Disiplin</button> */}
                                            {/* </Link> */}
                                        </div>
                                    </Card>
                                    : ""
                                    }
                                   <br />
                                    <Row className="mb-3">
                                        <Col md="9">
                                            <Link to="/kepegawaian/rekap_ketidakhadiran.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan memproses hukuman disipplin?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/hukuman_disiplin.html'/>
                : null }
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);